import { round } from 'lodash';
import { BridgeChartRow } from '../types';
import { getMiddleBridgeExtents } from './bridge-extents';

export const getBridgeZoomFloor = (chartRows: Array<BridgeChartRow>) => {
  const middleRows = chartRows.filter((row) => !row.isTotal);
  const { bridgeMin, bridgeMax } = getMiddleBridgeExtents(middleRows);
  const bridgeSpan = round(bridgeMax - bridgeMin, 2);

  return Math.max(0, round(bridgeMin - bridgeSpan, 2));
};

export const applyBridgeZoomTransform = (
  chartRows: Array<BridgeChartRow>,
  zoomFloor: number,
): Array<BridgeChartRow> =>
  chartRows.map((row) => {
    if (row.isTotal) {
      const visibleTop = round(row.displayValue - zoomFloor, 2);

      if (row.displayValue < 0) {
        return {
          ...row,
          base: visibleTop,
          value: round(Math.abs(visibleTop), 2),
        };
      }

      return {
        ...row,
        base: 0,
        value: round(Math.max(visibleTop, 0), 2),
      };
    }

    return {
      ...row,
      base: round(row.base - zoomFloor, 2),
      value: row.value,
    };
  });

export const positionTotalBarsOnReferenceLine = (
  chartRows: Array<BridgeChartRow>,
  referenceLineValue: number,
): Array<BridgeChartRow> =>
  chartRows.map((row) => {
    if (!row.isTotal || row.value <= 0) {
      return row;
    }

    const barTop = round(row.base + row.value, 2);
    const heightAboveReference = round(
      Math.max(barTop - referenceLineValue, 0),
      2,
    );

    if (heightAboveReference <= 0) {
      return row;
    }

    return {
      ...row,
      base: round(referenceLineValue, 2),
      value: heightAboveReference,
    };
  });
